import * as type from './type';
export default {
    [type.SET_CURRENT_STEP](state, currentStep) {
        state.currentStep = currentStep;
    },
    [type.SET_WARE_DETAIL](state, wareDetail) {
        state.wareDetail = wareDetail;
    },
    [type.SET_SELECTED](state, selected) {
        state.selectedList = selected;
    },
    [type.SET_COMBINATION](state, list) {
        state.combination = list;
    }
}


// WEBPACK FOOTER //
// ./src/store/create-ware/mutations.js